import { DealerSearchFilters } from "./models/dealers/dealer-search-filters";
import { UserSearchFilters } from "./models/users/user-search-filters";

/**
 * Users List Actions
 */
        export const SUPPORT_USERS_SEARCH_CLEAR_FILTERS     = 'SUPPORT_USERS_SEARCH_CLEAR_FILTERS';
        export const SUPPORT_USERS_SEARCH_UPDATE_FILTERS     = 'SUPPORT_USERS_SEARCH_UPDATE_FILTERS';

        /**
         * Action creator for update user search parameters
         * @param params The new parameters to save
         */
        export const updateUserSearchFilters = (params: UserSearchFilters) => ({
            type: SUPPORT_USERS_SEARCH_UPDATE_FILTERS,
            payload: params
        });

        /**
         * Clear the user list data from the store
         */
        export const clearUserSearch = () => ({
            type: SUPPORT_USERS_SEARCH_CLEAR_FILTERS,
            payload: {}
        });

/**
 * Dealers List Actions
 */

        export const SUPPORT_DEALERS_SEARCH_CLEAR_FILTERS     = 'SUPPORT_DEALERS_SEARCH_CLEAR_FILTERS';
        export const SUPPORT_DEALERS_SEARCH_UPDATE_FILTERS     = 'SUPPORT_DEALERS_SEARCH_UPDATE_FILTERS';

        /**
         * Action creator for update dealer search parameters
         * @param params The new parameters to save
         */
        export const updateDealerSearchFilters = (params: DealerSearchFilters) => ({
            type: SUPPORT_DEALERS_SEARCH_UPDATE_FILTERS,
            payload: params
        });

        /**
         * Clear the dealer list data from the store
         */
        export const clearDealerSearch = () => ({
            type: SUPPORT_DEALERS_SEARCH_CLEAR_FILTERS,
            payload: {}
        });
